import { AddItemModal } from "@/components/AddItemModal";
import type { ViewMode } from "@/types/viewMode";
import { IconButton } from "@ai-teach/ui-web";
import { Link } from "@tanstack/react-router";
import { HiPlus, HiViewGrid, HiViewList } from "react-icons/hi";
import { RiDeleteBin6Fill } from "react-icons/ri";

interface ActionButtonsProps {
  trashTo: string;
  trashCount: number;
  trashParams: Record<string, string>;
  viewMode?: ViewMode;
  onToggleView?: () => void;
  parentId?: string;
  onAdd?: () => void;
}

export function ActionButtons({
  trashTo,
  trashCount,
  trashParams,
  viewMode,
  onToggleView,
  parentId,
  onAdd,
}: ActionButtonsProps) {
  return (
    <div className="flex items-center gap-3">
      <Link
        to={trashTo}
        params={trashParams}
        className="inline-flex items-center gap-2 px-3 py-1.5 bg-white hover:bg-gray-50 text-gray-500 border border-gray-200 rounded-lg text-sm transition-colors"
      >
        <RiDeleteBin6Fill className="w-4 h-4" />
        <span>Trash</span>
        <span className="badge-secondary">{trashCount}</span>
      </Link>

      {viewMode && onToggleView && (
        <IconButton
          onClick={onToggleView}
          aria-label={`Switch to ${viewMode === "grid" ? "list" : "grid"} view`}
          variant="ghost"
        >
          {viewMode === "grid" ? (
            <HiViewList className="w-5 h-5" aria-hidden="true" title="List View" />
          ) : (
            <HiViewGrid className="w-5 h-5" aria-hidden="true" title="Grid View" />
          )}
        </IconButton>
      )}

      {onAdd ? (
        <IconButton
          aria-label="Add new item"
          variant="primary"
          shape="circle"
          size="md"
          onClick={onAdd}
        >
          <HiPlus className="w-5 h-5" aria-hidden="true" />
        </IconButton>
      ) : (
        <AddItemModal parentId={parentId} />
      )}
    </div>
  );
}
